var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.8 4 8 5.8 8 8V10C6.9 10 6 10.9 6 12V18C6 19.1 6.9 20 8 20H16C17.1 20 18 19.1 18 18V12C18 10.9 17.1 10 16 10V8C16 5.8 14.2 4 12 4ZM14 7.8C14 6.7 13.1 5.8 12 5.8C10.9 5.8 10 6.7 10 7.8V10H14V7.8ZM16 12V18H8V12H16Z",
    fill: "#19252E",
    fillOpacity: 0.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H13V17H11V13Z",
    fill: "#19252E",
    fillOpacity: 0.72
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lockGrey.b296ded56f3322d1e31dc28a0b8ff701.svg";